module.exports = __webpack_public_path__ + "media/packs/images/flags/GM-dfa2795a1339d0beb69a7a2e7c5106ad.svg";